import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { Box, FlatTile } from "@fedsim/components";
import { defaultCarouselOptions } from "./carousel.constants";

export function CarouselInner({ Tile, onClick, ...item }) {
  const clickHandler = () => onClick(item);

  return (
    <SplideSlide>
      <Tile {...item} onClick={clickHandler} />
    </SplideSlide>
  );
}

export function Carousel({
  Tile = FlatTile,
  collection = [],
  onClick = (item) => item,
  options = defaultCarouselOptions,
}): JSX.Element {
  const arrows = collection.length > options?.perPage;
  const newOptions = { arrows, ...options };
  return (
    <Box style={{ width: "100%" }}>
      <Splide aria-label={"collection of items"} options={newOptions}>
        {collection.map((item, index) => (
          <CarouselInner key={index} Tile={Tile} onClick={onClick} {...item} />
        ))}
      </Splide>
    </Box>
  );
}

export default Carousel;
